import { $ } from "@/common/Axios";

export default {
  /**
   * 上交高校
   */
  handSchool: {
    /*
     * 编辑上交高校
     * backAmount 返款金额 (number query )
     * backStatus 返款状态：未返款,已返款 (string query )
     * beforeTutorFee 考前辅导费 (number query )
     * confirmStatus 确认状态：未确认，确认上交，确认不上交 (string query )
     * fee 学费 (number query )
     * grade 缴费年级 (string query )
     * handId 上交人 (integer query )
     * handRemark 上交备注 (string query )
     * handStatus 上交状态：未上号,已上交,已结算,已返款 (string query )
     * id  (integer query )
     * noHandStatus 未上交状态： (string query )
     * receipt 发票 (string query )
     * remark 备注 (string query )
     * schoolRollId 学籍id (integer query )
     * settleAmount 高校结算金额 (number query )
     * tutorFee 辅导费 (number query )
     * type 类型：第一次缴费第二次缴费第三次缴费 (string query )
     */
    put: (p, c) => $.put("/api/fms/tuition/handSchool", p, c),

    /*
     * 删除上交高校（表示不用上交了）
     * id 上交高校id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/tuition/handSchool", p, c),
  },
  handSchool_batchUpdateNoHandStatus: {
    /*
     * 批量更新未上交状态
     * site 学校名称 (string query required)
     */
    put: (p, c) =>
      $.put("/api/fms/tuition/handSchool/batchUpdateNoHandStatus", p, c),
  },
  handSchool_changeHandId: {
    /*
     * 修改上交人
     * handId 上交人id (integer query required)
     * ids 上交高校id (array query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/handSchool/changeHandId", p, c),
  },
  handSchool_confirm: {
    /*
     * 确认
     * confirmStatus 确认状态：确认上交，确认不上交 (string query required)
     * ids 上交高校ids (array query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/handSchool/confirm", p, c),
  },
  handSchool_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchool/export", p, c),
  },
  handSchool_exportForEducation: {
    /*
     * 教务导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSchool/exportForEducation", p, c),
  },
  handSchool_exportForSearchText: {
    /*
     * 根据查询字段导出
     * searchText 查询字段 (string query required)
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSchool/exportForSearchText", p, c),
  },
  handSchool_exportForService: {
    /*
     * 服务导出
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchool/exportForService", p, c),
  },
  handSchool_handRemark: {
    /*
     * 上交备注
     * handRemark 上交备注 (string query required)
     * id 上交高校id (integer query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/handSchool/handRemark", p, c),
  },
  handSchool_init: {
    /*
     * 初始化上交高校数据
     * feeType 缴费类型：第一次缴费,第二次缴费，第三次缴费 (string query required)
     * rollGrade 学籍年级 (string query required)
     * siteType 学校类型：成教,远程,国开 (string query required)
     */
    post: (p, c) => $.post("/api/fms/tuition/handSchool/init", p, c),
  },
  handSchool_initOne: {
    /*
     * 单个初始化上交高校数据
     * feeType 缴费类型：第一次缴费,第二次缴费，第三次缴费 (string query required)
     * schoolRollId 合同编号 (integer query required)
     */
    post: (p, c) => $.post("/api/fms/tuition/handSchool/initOne", p, c),
  },
  handSchool_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchool/list", p, c),
  },
  handSchool_listForEducation: {
    /*
     * 上交高校教务列表
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchool/listForEducation", p, c),
  },
  handSchool_listForPayment: {
    /*
     * 简易上交高校列表
     * schoolRollId 学籍id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchool/listForPayment", p, c),
  },
  handSchool_listForService: {
    /*
     * 上交高校服务列表
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchool/listForService", p, c),
  },
  handSchool_listSimple: {
    /*
     * 简易上交高校列表
     * schoolRollId 学籍id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchool/listSimple", p, c),
  },
  handSchool_receipt: {
    /*
     * 上传发票
     * id 上交高校id (integer query required)
     * receipt 发票 (string query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/handSchool/receipt", p, c),
  },
  handSchool_remindConfirm: {
    /*
     * 确认提醒
     * searchText 查询字段 (string query required)
     * text 提醒内容 (string query required)
     */
    post: (p, c) => $.post("/api/fms/tuition/handSchool/remindConfirm", p, c),
  },
  handSchool_remindReminder: {
    /*
     * 缴费提醒
     * searchText 查询字段 (string query required)
     * text 提醒内容 (string query required)
     */
    post: (p, c) => $.post("/api/fms/tuition/handSchool/remindReminder", p, c),
  },
  handSchool_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/fms/tuition/handSchool/upload", p, c),
  },

  /**
   * 钉钉上交高校
   */
  handSchoolDingtalk: {
    /*
     * 添加
     * adminTeacher 合同负责人|列表||| (string query )
     * adminTeacherId 合同负责人id|筛选||ID下拉|api/bms/system/admin/listAdmin (integer query )
     * advancesAmount 垫付金额|列表||| (number query )
     * advancesRemark 垫付备注|全部||| (string query )
     * applyAmount 申请上交金额|列表||| (number query )
     * backAmount 下级返款金额|列表||| (number query )
     * beforeTutorFee 考前辅导费|列表||| (number query )
     * confirmStatus 确认状态|全部||字符串下拉|api/bms/develop/config/listSelect?key=上交高校确认状态 (string query )
     * department 合同部门|列表||| (string query )
     * diffFee 公司承担学费差异|列表||| (number query )
     * dingtalkNo 钉钉审批号|全部||| (string query )
     * fee 学费|列表||| (number query )
     * grade 缴费年级|全部||| (string query )
     * hand 付款人|列表||| (string query )
     * handAccount 付款账号|全部||字符串下拉|api/fms/finance/account/listName (string query )
     * handAmount 实际上交金额|列表||| (number query )
     * handStatus 上交状态|全部||字符串下拉|api/bms/develop/config/listSelect?key=钉钉上交高校状态 (string query )
     * handTime 付款日期|全部|日期|日期| (string query )
     * headerTeacher 班主任|列表||| (string query )
     * headerTeacherId 班主任id|筛选||ID下拉|api/bms/system/admin/listAdmin (integer query )
     * id 钉钉上交高校编号|列表||| (string query )
     * idCardNo 身份证号|全部||| (string query )
     * level 层次|全部||字符串下拉|api/bms/develop/config/listSelect?key=学历专业层次 (string query )
     * major 专业|全部||| (string query )
     * name 学生姓名|全部||| (string query )
     * needAccount 上交所需账号|列表||| (string query )
     * passTime 审批通过时间|全部|日期|日期| (string query )
     * phone 手机号|全部||| (string query )
     * remark 备注|全部||| (string query )
     * rollGrade 学籍年级|全部||| (string query )
     * schoolAccount 平台账号|列表||| (string query )
     * schoolPassword 平台密码|列表||| (string query )
     * schoolRollId 合同编号|全部||| (string query )
     * schoolStatus 学籍状态|全部||字符串下拉|api/ems/basic/schoolStatus/config/listSchoolStatus (string query )
     * screenshots 截图|列表|图片|| (string query )
     * settleAccount 结算方|全部||字符串下拉|api/ems/education/schoolRoll/listSettleAccount (string query )
     * settleAmount 高校结算金额|列表||| (number query )
     * settleDeductAmount 高校结算扣除项|列表||| (number query )
     * site 学校|全部||字符串下拉|api/ems/basic/site/listName (string query )
     * sort 打款序号|列表||| (integer query )
     * studentNo 学号|全部||| (string query )
     * tutorFee 辅导费|列表||| (number query )
     * type 费用类型|全部||字符串下拉|api/bms/develop/config/listSelect?key=上交高校类型 (string query )
     */
    post: (p, c) => $.post("/api/fms/tuition/handSchoolDingtalk", p, c),

    /*
     * 删除
     * id 钉钉上交高校id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/tuition/handSchoolDingtalk", p, c),
  },
  handSchoolDingtalk_amount: {
    /*
     * 金额
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchoolDingtalk/amount", p, c),
  },
  handSchoolDingtalk_batchPay: {
    /*
     * 批量打款
     * dingtalkNo 钉钉审批号 (string query required)
     * handAccount 付款账户 (string query required)
     * handTime 付款日期，默认当前 (string query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/handSchoolDingtalk/batchPay", p, c),
  },
  handSchoolDingtalk_batchRemove: {
    /*
     * 批量删除
     * ids 钉钉上交高校id (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/fms/tuition/handSchoolDingtalk/batchRemove", p, c),
  },
  handSchoolDingtalk_batchUpdatePassTime: {
    /*
     * 批量修改审核通过时间
     * dingtalkNo 钉钉审批号 (string query required)
     * passTime 付款日期，默认当前 (string query required)
     */
    put: (p, c) =>
      $.put("/api/fms/tuition/handSchoolDingtalk/batchUpdatePassTime", p, c),
  },
  handSchoolDingtalk_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchoolDingtalk/export", p, c),
  },
  handSchoolDingtalk_getDefaultHandAccount: {
    /*
     * 获取默认的付款账户
     * dingtalkNo 钉钉审批号 (string query required)
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSchoolDingtalk/getDefaultHandAccount", p, c),
  },
  handSchoolDingtalk_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchoolDingtalk/list", p, c),
  },
  handSchoolDingtalk_mark: {
    /*
     * 标记|取消标记
     * id id (integer query required)
     * remark 备注 (string query )
     * type 类型：标记，取消标记 (string query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/handSchoolDingtalk/mark", p, c),
  },
  handSchoolDingtalk_pay: {
    /*
     * 单个打款
     * handAccount 付款账户 (string query required)
     * handAmount 实际上交金额，默认从应交中取 (number query required)
     * handTime 付款日期，默认当前 (string query required)
     * id id (integer query required)
     * screenshots 截图 (string query )
     */
    put: (p, c) => $.put("/api/fms/tuition/handSchoolDingtalk/pay", p, c),
  },
  handSchoolDingtalk_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/fms/tuition/handSchoolDingtalk/upload", p, c),
  },
  handSchoolDingtalk_uploadPay: {
    /*
     * 批量导入打款
     * excelFile excelFile (file formData required)
     * handTime 付款日期，默认当前 (string query required)
     */
    post: (p, c) =>
      $.post("/api/fms/tuition/handSchoolDingtalk/uploadPay", p, c),
  },

  /**
   * 上交高校信息
   */
  handSchoolInfo_view: {
    /*
     * 上交高校视图
     * batch 批次 (string query required)
     * feeType 缴费类型：第一次缴费,第二次缴费，第三次缴费 (string query required)
     * schoolStatuses 学籍状态 (array query required)
     * siteType 学校类型 (string query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchoolInfo/view", p, c),
  },

  /**
   * 学费上交及结算标准
   */
  handSettlementStandard: {
    /*
     * 添加
     * beforeTutorFee 考前辅导费 (number query )
     * city 市 (string query )
     * district 区县 (string query )
     * estimate 预估 (string query )
     * fee 学费 (number query )
     * feeType 费用类型 (string query )
     * id  (integer query )
     * majorId 专业id (integer query )
     * repeatedly 是否多次 (string query )
     * rollGrade 学籍年级 (string query )
     * settleAmount 高校结算金额 (number query )
     * settlementOrg 结算单位 (string query )
     * sign 合同签订 (string query )
     * tutorFee 辅导费 (number query )
     */
    post: (p, c) => $.post("/api/fms/tuition/handSettlementStandard", p, c),
  },
  handSettlementStandard_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/export", p, c),
  },
  handSettlementStandard_exportForArmySkill: {
    /*
     * 退伍军人技能培训导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/exportForArmySkill", p, c),
  },
  handSettlementStandard_exportForContinue: {
    /*
     * 继教院导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/exportForContinue", p, c),
  },
  handSettlementStandard_exportForEducation: {
    /*
     * 成教导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/exportForEducation", p, c),
  },
  handSettlementStandard_exportForExemptionDegree: {
    /*
     * 免试专升本导出
     */
    get: (p, c) =>
      $.get(
        "/api/fms/tuition/handSettlementStandard/exportForExemptionDegree",
        p,
        c
      ),
  },
  handSettlementStandard_exportForSelf: {
    /*
     * 自考导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/exportForSelf", p, c),
  },
  handSettlementStandard_exportForSkillTrain: {
    /*
     * 技能培训导出
     */
    get: (p, c) =>
      $.get(
        "/api/fms/tuition/handSettlementStandard/exportForSkillTrain",
        p,
        c
      ),
  },
  handSettlementStandard_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/tuition/handSettlementStandard/list", p, c),
  },
  handSettlementStandard_listForArmySkill: {
    /*
     * 退伍军人技能培训列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/listForArmySkill", p, c),
  },
  handSettlementStandard_listForContinue: {
    /*
     * 继教院列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/listForContinue", p, c),
  },
  handSettlementStandard_listForEducation: {
    /*
     * 成教列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/listForEducation", p, c),
  },
  handSettlementStandard_listForExemptionDegree: {
    /*
     * 免试专升本列表
     */
    get: (p, c) =>
      $.get(
        "/api/fms/tuition/handSettlementStandard/listForExemptionDegree",
        p,
        c
      ),
  },
  handSettlementStandard_listForSelf: {
    /*
     * 自考列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/listForSelf", p, c),
  },
  handSettlementStandard_listForSkillTrain: {
    /*
     * 技能培训列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/listForSkillTrain", p, c),
  },
  handSettlementStandard_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/fms/tuition/handSettlementStandard/upload", p, c),
  },

  /**
   * 下级返款标准
   */
  rebateStandard: {
    /*
     * 添加
     * amount 返款金额 (number query )
     * enrollTeacherId 招生老师id (integer query )
     * estimate 预估 (string query )
     * feeType 费用类型 (string query )
     * id  (integer query )
     * majorId 专业id (integer query )
     * rebateOrg 结算单位 (string query )
     * rollGrade 学籍年级 (string query )
     * sign 合同签订 (string query )
     */
    post: (p, c) => $.post("/api/fms/tuition/rebateStandard", p, c),
  },
  rebateStandard_export: {
    /*
     * 批量导出
     */
    get: (p, c) => $.get("/api/fms/tuition/rebateStandard/export", p, c),
  },
  rebateStandard_exportForContinue: {
    /*
     * 继教院导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/rebateStandard/exportForContinue", p, c),
  },
  rebateStandard_exportForEducation: {
    /*
     * 成教导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/rebateStandard/exportForEducation", p, c),
  },
  rebateStandard_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/tuition/rebateStandard/list", p, c),
  },
  rebateStandard_listForContinue: {
    /*
     * 继教院列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/rebateStandard/listForContinue", p, c),
  },
  rebateStandard_listForEducation: {
    /*
     * 成教列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/rebateStandard/listForEducation", p, c),
  },
  rebateStandard_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/fms/tuition/rebateStandard/upload", p, c),
  },

  /**
   * 返款计划
   */
  refundPlan: {
    /*
     * 添加
     * amount 已返款金额 (number query )
     * feeType 缴费类型 (string query )
     * id  (integer query )
     * needAmount 应返款金额 (number query )
     * planAmount 纳入计划金额 (number query )
     * planTime 计划时间 (string query )
     * project 项目 (string query )
     * refundTime 实际返款时间 (string query )
     * refundType 返款类型：正常，额外 (string query )
     * remark 备注 (string query )
     * rollGrade 学籍年级 (string query )
     * schoolRollIds 合同id (string query )
     * siteId 学校id (integer query )
     * studentCount 学生数 (integer query )
     */
    post: (p, c) => $.post("/api/fms/tuition/refundPlan", p, c),

    /*
     * 修改
     * amount 已返款金额 (number query )
     * feeType 缴费类型 (string query )
     * id  (integer query )
     * needAmount 应返款金额 (number query )
     * planAmount 纳入计划金额 (number query )
     * planTime 计划时间 (string query )
     * project 项目 (string query )
     * refundTime 实际返款时间 (string query )
     * refundType 返款类型：正常，额外 (string query )
     * remark 备注 (string query )
     * rollGrade 学籍年级 (string query )
     * schoolRollIds 合同id (string query )
     * siteId 学校id (integer query )
     * studentCount 学生数 (integer query )
     */
    put: (p, c) => $.put("/api/fms/tuition/refundPlan", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/tuition/refundPlan", p, c),
  },
  refundPlan_addStudent: {
    /*
     * 添加学生
     * id id (integer query required)
     * schoolRollIds 学生id (array query required)
     */
    post: (p, c) => $.post("/api/fms/tuition/refundPlan/addStudent", p, c),
  },
  refundPlan_deleteStudent: {
    /*
     * 删除学生
     * id id (integer query required)
     * schoolRollIds 学生id (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/fms/tuition/refundPlan/deleteStudent", p, c),
  },
  refundPlan_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/export", p, c),
  },
  refundPlan_exportForLate: {
    /*
     * 逾期返款计划列表导出
     * siteType 学校类型 (string query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/exportForLate", p, c),
  },
  refundPlan_exportForMonth: {
    /*
     * 月返款计划列表导出
     * siteType 学校类型 (string query required)
     * timeType 时间类型：上月，当月，下月 (string query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/exportForMonth", p, c),
  },
  refundPlan_exportForOut: {
    /*
     * 未纳入返款计划导出
     * siteType 学校类型 (string query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/exportForOut", p, c),
  },
  refundPlan_exportStudent: {
    /*
     * 导出学生列表
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/exportStudent", p, c),
  },
  refundPlan_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/list", p, c),
  },
  refundPlan_listForLate: {
    /*
     * 逾期返款计划列表
     * siteType 学校类型 (string query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/listForLate", p, c),
  },
  refundPlan_listForMonth: {
    /*
     * 月返款计划列表
     * siteType 学校类型 (string query required)
     * timeType 时间类型：上月，当月，下月 (string query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/listForMonth", p, c),
  },
  refundPlan_listForOut: {
    /*
     * 未纳入返款计划
     * siteType 学校类型 (string query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/listForOut", p, c),
  },
  refundPlan_listStudent: {
    /*
     * 学生列表
     * id id (integer query required)
     * name 学生姓名 (string query )
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/listStudent", p, c),
  },
  refundPlan_listSubPlan: {
    /*
     * 子计划列表
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/listSubPlan", p, c),
  },
  refundPlan_refund: {
    /*
     * 返款
     * id id (integer query required)
     * refundTime 返款时间 (string query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/refundPlan/refund", p, c),
  },
  refundPlan_remark: {
    /*
     * 备注
     * id id (integer query required)
     * remark 备注 (string query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/refundPlan/remark", p, c),
  },
  refundPlan_syncStudent: {
    /*
     * 同步学生
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/refundPlan/syncStudent", p, c),
  },
  refundPlan_upload: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/fms/tuition/refundPlan/upload", p, c),
  },
  refundPlan_uploadStudent: {
    /*
     * 导入学生
     * file file (file formData required)
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/fms/tuition/refundPlan/uploadStudent", p, c),
  },

  /**
   * 学费信息
   */
  tuition_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/fms/tuition/tuition/export", p, c),
  },
  tuition_exportForBigData: {
    /*
     * 大数据导出
     */
    get: (p, c) => $.get("/api/fms/tuition/tuition/exportForBigData", p, c),
  },
  tuition_list: {
    /*
     * 学费列表
     */
    get: (p, c) => $.get("/api/fms/tuition/tuition/list", p, c),
  },
  tuition_updateCollecting: {
    /*
     * 编辑代收
     * accountingCollectingBeforeTutorFee 收费单入账代收考前辅导费|列表||| (number query )
     * accountingCollectingFee 收费单入账代收学费|列表||| (number query )
     * accountingCollectingTutorFee 收费单入账代收辅导费|列表||| (number query )
     * accountingFeeNoteFee 收费单入账应收|列表||| (number query )
     * accountingOrderAmount 订单入账实收|列表||| (number query )
     * beforeTutorFee 考前辅导费|列表||| (number query )
     * collectingBeforeTutorFee 代收考前辅导费|列表||| (number query )
     * contractFinishTime 合同成交日期|列表|时间|| (string query )
     * department 合同部门|列表||| (string query )
     * enrollLevel 层次|全部||字符串下拉|api/bms/develop/config/listSelect?key=学历专业层次 (string query )
     * estimatedIncome 预估收入|列表||| (number query )
     * estimatedProfit 预估利润|列表||| (number query )
     * fifthCollectingFee 第五次代收学费|列表||| (number query )
     * fifthCollectingTutorFee 第五次代收辅导费|列表||| (number query )
     * fifthFee 第五次学费|列表||| (number query )
     * fifthFeeAccountingTime 第五次收费单入账时间|无||| (string query )
     * fifthFeeFee 第五次收费单应收|无||| (number query )
     * fifthTutorFee 第五次辅导费|列表||| (number query )
     * firstCollectingFee 第一次代收学费|列表||| (number query )
     * firstCollectingTutorFee 第一次代收辅导费|列表||| (number query )
     * firstFee 第一次学费|列表||| (number query )
     * firstFeeAccountingTime 第一次收费单入账时间|无||| (string query )
     * firstFeeFee 第一次收费单应收|无||| (number query )
     * firstTutorFee 第一次辅导费|列表||| (number query )
     * fourthCollectingFee 第四次代收学费|列表||| (number query )
     * fourthCollectingTutorFee 第四次代收辅导费|列表||| (number query )
     * fourthFee 第四次学费|列表||| (number query )
     * fourthFeeAccountingTime 第四次收费单入账时间|无||| (string query )
     * fourthFeeFee 第四次收费单应收|无||| (number query )
     * fourthTutorFee 第四次辅导费|列表||| (number query )
     * handedBeforeTutorFee 已上交入学考试辅导费|列表||| (number query )
     * handedFee 已上交学费|列表||| (number query )
     * handedTutorFee 已上交辅导费|列表||| (number query )
     * id 学费id|无||| (integer query )
     * idCardNo 身份证号|全部||| (string query )
     * major 专业|列表||| (string query )
     * name 学生姓名|全部||| (string query )
     * oldType 是否老生|列表||| (string query )
     * onceFeeAccountingTime 一次性收费单入账时间|无||| (string query )
     * onceFeeFee 一次性收费单应收|无||| (number query )
     * paymentOrderAmount 退费订单入账实收|列表||| (number query )
     * realIncome 实际收入|列表||| (number query )
     * realProfit 实际利润|列表||| (number query )
     * referral 推荐人|列表||| (string query )
     * rollGrade 学籍年级|全部||| (string query )
     * schoolRollId 合同编号|全部||| (string query )
     * schoolStatus 学籍状态|全部||字符串下拉|api/ems/basic/schoolStatus/config/listSchoolStatus (string query )
     * secondCollectingFee 第二次代收学费|列表||| (number query )
     * secondCollectingTutorFee 第二次代收辅导费|列表||| (number query )
     * secondFee 第二次学费|列表||| (number query )
     * secondFeeAccountingTime 第二次收费单入账时间|无||| (string query )
     * secondFeeFee 第二次收费单应收|无||| (number query )
     * secondTutorFee 第二次辅导费|列表||| (number query )
     * settleAccount 结算方|全部||字符串下拉|api/ems/education/schoolRoll/listSettleAccount (string query )
     * site 学校|全部||字符串下拉|api/ems/basic/site/listName (string query )
     * siteType 学校类型|全部||字符串下拉|api/ems/basic/site/listType?platform=#{当前平台} (string query )
     * sourceFrom 来源详情|列表||| (string query )
     * thirdCollectingFee 第三次代收学费|列表||| (number query )
     * thirdCollectingTutorFee 第三次代收辅导费|列表||| (number query )
     * thirdFee 第三次学费|列表||| (number query )
     * thirdFeeAccountingTime 第三次收费单入账时间|无||| (string query )
     * thirdFeeFee 第三次收费单应收|无||| (number query )
     * thirdTutorFee 第三次辅导费|列表||| (number query )
     */
    put: (p, c) => $.put("/api/fms/tuition/tuition/updateCollecting", p, c),
  },
  tuition_updateTuitionInfoByBatchTransaction: {
    /*
     * 批量异动该学费
     * beforeTutorFee 考前辅导费 (number query required)
     * firstDiscountAmount 第一次优惠金额 (number query required)
     * firstDiscountType 第一次优惠类型 (string query )
     * firstFee 第一次学费 (number query required)
     * firstTutorFee 第一次辅导费 (number query required)
     * onceDiscountAmount 一次性缴费优惠金额 (number query required)
     * onceDiscountType 一次性优惠类型 (string query )
     * periods 缴费次数 (integer query required)
     * schoolRollId 合同id (integer query required)
     * secondDiscountAmount 第二次优惠金额 (number query required)
     * secondDiscountType 第二次优惠类型 (string query )
     * secondFee 第二次学费 (number query required)
     * secondTutorFee 第二次辅导费 (number query required)
     * thirdDiscountAmount 第三次优惠金额 (number query required)
     * thirdDiscountType 第三次优惠类型 (string query )
     * thirdFee 第三次学费 (number query required)
     * thirdTutorFee 第三次辅导费 (number query required)
     */
    put: (p, c) =>
      $.put(
        "/api/fms/tuition/tuition/updateTuitionInfoByBatchTransaction",
        p,
        c
      ),
  },
  tuition_uploadCollecting: {
    /*
     * 导入代收
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/fms/tuition/tuition/uploadCollecting", p, c),
  },
  tuition_uploadSettleAccount: {
    /*
     * 导入结算方
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/fms/tuition/tuition/uploadSettleAccount", p, c),
  },

  /**
   * 学费收费配置
   */
  tuitionFeeConfig: {
    /*
     * 添加
     * alipayAccount 支付宝支付账号 (string query )
     * firstFee 第一次缴费费用 (number query )
     * hccbAccount 杭州银行支付账号 (string query )
     * huifuAccount 汇付支付账号 (string query )
     * id  (integer query )
     * site 学校 (string query )
     * wechatAccount 微信支付账号 (string query )
     */
    post: (p, c) => $.post("/api/fms/tuition/tuitionFeeConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/tuition/tuitionFeeConfig", p, c),
  },
  tuitionFeeConfig_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionFeeConfig/export", p, c),
  },
  tuitionFeeConfig_getBySite: {
    /*
     * 根据学校获取缴费信息
     * site 学校 (string query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionFeeConfig/getBySite", p, c),
  },
  tuitionFeeConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionFeeConfig/list", p, c),
  },
  tuitionFeeConfig_listSite: {
    /*
     * 学校列表
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionFeeConfig/listSite", p, c),
  },
  tuitionFeeConfig_upload: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/fms/tuition/tuitionFeeConfig/upload", p, c),
  },

  /**
   * 学历退费单
   */
  tuitionPayment: {
    /*
     * 编辑付款单
     * account 账号 (string query required)
     * accountNick 退款账号昵称 (string query required)
     * accountType 退款账号类型 (string query required)
     * amount 金额 (number query )
     * applyRemark 申请备注 (string query )
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/tuitionPayment", p, c),

    /*
     * 删除付款单
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/tuition/tuitionPayment", p, c),
  },
  tuitionPayment_audit: {
    /*
     * 审核
     * auditStatus 审核状态 (string query required)
     * confirmed 确认 (boolean query )
     * discountFee 扣回优惠返款金额 (number query )
     * fee 应退金额 (number query )
     * id id (integer query required)
     * remark 备注 (string query )
     * schoolFee 代高校垫付金额 (number query )
     */
    put: (p, c) => $.put("/api/fms/tuition/tuitionPayment/audit", p, c),
  },
  tuitionPayment_createRefundPayment: {
    /*
     * 创建退费付款单（退学审核通过后调用）
     * account 退款账号 (string query required)
     * accountNick 退款账号昵称 (string query required)
     * accountType 退款账号类型 (string query required)
     * amount 退款金额 (number query required)
     * changeId 异动id (integer query required)
     * remark 备注 (string query )
     * schoolRollId 学籍id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/fms/tuition/tuitionPayment/createRefundPayment", p, c),
  },
  tuitionPayment_detailsRefund: {
    /*
     * 退费付款单详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionPayment/detailsRefund", p, c),
  },
  tuitionPayment_exportRefund: {
    /*
     * 导出退费付款单
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionPayment/exportRefund", p, c),
  },
  tuitionPayment_getByChangeId: {
    /*
     * 根据异动单id获取退费付款单详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionPayment/getByChangeId", p, c),
  },
  tuitionPayment_listRefund: {
    /*
     * 退费付款单列表
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionPayment/listRefund", p, c),
  },
  tuitionPayment_listRefundBySchoolRollId: {
    /*
     * 根据合同id获取退费付款单详情
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/tuitionPayment/listRefundBySchoolRollId", p, c),
  },
  tuitionPayment_pay: {
    /*
     * 打款
     * id id (integer query required)
     * payAccount 打款账号 (string query required)
     * payRemark 备注 (string query )
     */
    put: (p, c) => $.put("/api/fms/tuition/tuitionPayment/pay", p, c),
  },
  tuitionPayment_updateCollecting: {
    /*
     * 编辑代收预收
     * account 退款账号|列表||| (string query )
     * accountNick 退款账号名称|列表||| (string query )
     * accountType 退款账号类型|列表||| (string query )
     * amount 申请金额|列表||| (number query )
     * apply 申请人姓名|列表||| (string query )
     * applyDepartment 申请人部门|列表||| (string query )
     * applyRemark 申请备注|列表||| (string query )
     * audit 审核人姓名|列表||| (string query )
     * auditRemark 审核备注|列表||| (string query )
     * auditStatus 审核状态|全部||字符串下拉|api/bms/develop/config/listSelect?key=审核状态 (string query )
     * auditTime 审核时间|全部|时间|时间| (string query )
     * beforeTutorFee 考前辅导费|无||| (number query )
     * collectingBeforeTutorFee 代收考前辅导费|列表||| (number query )
     * collectingFee 代收学费|列表||| (number query )
     * collectingTutorFee 代收辅导费|列表||| (number query )
     * contractFinishTime 合同成交日期|全部|时间|时间| (string query )
     * department 合同部门|列表||| (string query )
     * discountFee 扣回优惠返款金额|列表||| (number query )
     * enrollLevel 层次|全部||字符串下拉|api/bms/develop/config/listSelect?key=学历专业层次 (string query )
     * estimatedIncome 预计收入|列表||| (number query )
     * estimatedPerformanceIncome 预计业绩收入|列表||| (number query )
     * fee 应退金额|列表||| (number query )
     * fifthAccountingTime 第五次缴费入账时间|无||| (string query )
     * fifthDiscount 第五次缴费优惠金额|无||| (number query )
     * fifthFee 第五次学费|无||| (number query )
     * fifthTutorFee 第五次辅导费|无||| (number query )
     * firstAccountingTime 第一次缴费入账时间|无||| (string query )
     * firstDiscount 第一次缴费优惠金额|无||| (number query )
     * firstFee 第一次学费|无||| (number query )
     * firstTutorFee 第一次辅导费|无||| (number query )
     * fourthAccountingTime 第四次缴费入账时间|无||| (string query )
     * fourthDiscount 第四次缴费优惠金额|无||| (number query )
     * fourthFee 第四次学费|无||| (number query )
     * fourthTutorFee 第四次辅导费|无||| (number query )
     * id 退费单号|全部||| (string query )
     * idCardNo 身份证号|全部||| (string query )
     * major 专业|列表||| (string query )
     * name 学生姓名|全部||| (string query )
     * onceAccountingTime 一次性缴费入账时间|无||| (string query )
     * onceDiscount 一次性缴费优惠金额|无||| (number query )
     * pay 打款人姓名|列表||| (string query )
     * payStatus 打款状态|全部||字符串下拉|api/bms/develop/config/listSelect?key=打款状态 (string query )
     * payTime 打款时间|全部|时间|时间| (string query )
     * preCollectingBeforeTutorFee 预收考前辅导费|列表||| (number query )
     * preCollectingFee 预收学费|列表||| (number query )
     * preCollectingTutorFee 预收辅导费|列表||| (number query )
     * realIncome 实际收入|列表||| (number query )
     * rollGrade 学籍年级|全部||| (string query )
     * salesDiscount 销售折扣|列表||| (number query )
     * schoolFee 高校金额（垫付/已结算）|列表||| (number query )
     * schoolRollId 合同编号|全部||| (string query )
     * schoolStatus 学籍状态|全部||字符串下拉|api/ems/basic/schoolStatus/config/listSchoolStatus (string query )
     * secondAccountingTime 第二次缴费入账时间|无||| (string query )
     * secondDiscount 第二次缴费优惠金额|无||| (number query )
     * secondFee 第二次学费|无||| (number query )
     * secondTutorFee 第二次辅导费|无||| (number query )
     * site 学校|全部||字符串下拉|api/ems/basic/site/listName (string query )
     * siteType 学校类型|全部||字符串下拉|api/ems/basic/site/listType?platform=#{当前平台} (string query )
     * thirdAccountingTime 第三次缴费入账时间|无||| (string query )
     * thirdDiscount 第三次缴费优惠金额|无||| (number query )
     * thirdFee 第三次学费|无||| (number query )
     * thirdTutorFee 第三次辅导费|无||| (number query )
     * totalBeforeTutorFee 总考前辅导费|列表||| (number query )
     * totalDiscount 总优惠金额|列表||| (number query )
     * totalFee 总学费|列表||| (number query )
     * totalTutorFee 总辅导费|列表||| (number query )
     * tuitionStatus 缴费状态|全部||字符串下拉|api/bms/develop/config/listSelect?key=学历缴费状态 (string query )
     * userId 用户id|无||| (integer query )
     */
    put: (p, c) =>
      $.put("/api/fms/tuition/tuitionPayment/updateCollecting", p, c),
  },
  tuitionPayment_uploadCollecting: {
    /*
     * 导入代收预收
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/fms/tuition/tuitionPayment/uploadCollecting", p, c),
  },

  /**
   * 学历退费订单
   */
  tuitionPaymentOrder_audit: {
    /*
     * 审核
     * auditStatus 审核状态：通过，拒绝 (string query required)
     * id 退费订单id (integer query required)
     * orderNo 订单号 (string query required)
     * remark 备注 (string query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/tuitionPaymentOrder/audit", p, c),
  },
  tuitionPaymentOrder_details: {
    /*
     * 详情
     * id 退费订单id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionPaymentOrder/details", p, c),
  },
  tuitionPaymentOrder_detailsForNight: {
    /*
     * 详情
     * id 退费订单id (integer query required)
     * studentId 学生id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/tuitionPaymentOrder/detailsForNight", p, c),
  },
  tuitionPaymentOrder_detailsForStudentFees: {
    /*
     * 详情
     * id 退费订单id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/tuitionPaymentOrder/detailsForStudentFees", p, c),
  },
  tuitionPaymentOrder_downloadRestoreModule: {
    /*
     * 下载修复模版
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/tuitionPaymentOrder/downloadRestoreModule", p, c),
  },
  tuitionPaymentOrder_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionPaymentOrder/export", p, c),
  },
  tuitionPaymentOrder_exportForNight: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/tuitionPaymentOrder/exportForNight", p, c),
  },
  tuitionPaymentOrder_exportForStudentFees: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/tuitionPaymentOrder/exportForStudentFees", p, c),
  },
  tuitionPaymentOrder_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionPaymentOrder/list", p, c),
  },
  tuitionPaymentOrder_listForNight: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/tuitionPaymentOrder/listForNight", p, c),
  },
  tuitionPaymentOrder_listForStudentFees: {
    /*
     * 学生缴费单列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/tuitionPaymentOrder/listForStudentFees", p, c),
  },
  tuitionPaymentOrder_pay: {
    /*
     * 打款
     * auditRemark 备注 (string query required)
     * id 退费订单id (integer query required)
     * orderNo 订单号 (string query required)
     * payAccount 打款账号 (string query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/tuitionPaymentOrder/pay", p, c),
  },
  tuitionPaymentOrder_restore: {
    /*
     * 修复
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/fms/tuition/tuitionPaymentOrder/restore", p, c),
  },
};
